import React, { useMemo } from "react";
import { useTicket } from "../../../store/Store";
import { processAdjustmentsData } from "../../general/AppHelpers";
import AdjustmentItem from "../AdjustmentItem";
import { MiscItemIcon } from "../../general/Icons";
import { useTranslation } from "react-i18next";

const MiscItems = () => {
  const { data: ticketData } = useTicket();
  const { t } = useTranslation();

  const { miscItemAdjustments } = useMemo(
    () => processAdjustmentsData(ticketData?.resource?.adjustments),
    [ticketData]
  );

  const miscItemAdjustmentElements = useMemo(() => {
    return miscItemAdjustments?.map(({ adjustment, associatedTaxes }, index) => (
      <AdjustmentItem
        key={`misc-item-${index}`}
        adjustment={adjustment}
        taxes={associatedTaxes}
      />
    ));
  }, [miscItemAdjustments]);

  if (!miscItemAdjustmentElements?.length) return null;

  return (
    <div className="py-5" data-testid="misc-items-container">
      <div className="flex items-center gap-2 mb-2" data-testid="misc-items-header">
        <MiscItemIcon />
        <h3 className="text-lg font-medium text-black" data-testid="misc-items-title">
          {t("ticketItemsSections.miscItems")}
        </h3>
      </div>
      <div className="flex flex-col gap-2" data-testid="misc-items-list">{miscItemAdjustmentElements}</div>
    </div>
  );
};

export default MiscItems;
